const PREVIEW_MAX_WIDTH = 720;
const PREVIEW_JPEG_QUALITY = 0.62;

function canvasToPreviewDataUrl(sourceCanvas) {

  const srcW = sourceCanvas?.width || 0;
  const srcH = sourceCanvas?.height || 0;

  if (!srcW || !srcH) return '';

  const scale = Math.min(1, PREVIEW_MAX_WIDTH / srcW);
  const width = Math.max(1, Math.round(srcW * scale));
  const height = Math.max(1, Math.round(srcH * scale));
  const canvas = document.createElement('canvas');

  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');

  if (!context) return '';

  context.drawImage(sourceCanvas, 0, 0, width, height);

  return canvas.toDataURL('image/jpeg', PREVIEW_JPEG_QUALITY);

}

export default canvasToPreviewDataUrl;
